<template>
  <div class="map_stat_data">
    <div class="stat_data_inner">
      <div class="stat_data_left"><span class="stat_title">全国</span></div>
      <div class="stat_data_right">
        <div class="stat_item">
          <div class="Akrobat-ExtraBold">{{ statistic.cityNum }}</div>
          <p class="item_label">覆盖城市</p>
        </div>
        <div class="stat_item">
          <div class="Akrobat-ExtraBold">
            {{ statistic.deviceNum | num2myriad }}
            <span v-if="statistic.deviceNum && statistic.deviceNum > 0" class="unit">万</span>
          </div>
          <p class="item_label">广告屏幕(个)</p>
        </div>
        <div class="stat_item">
          <div class="Akrobat-ExtraBold">
            {{ statistic.people | num2myriad }}
            <span v-if="statistic.people && statistic.people > 0" class="unit">万</span>
          </div>
          <p class="item_label">覆盖人群(人)</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopStat',
  filters: {
    num2myriad(v) {
      if (v && v < 0) return '--'
      return v && v > 0 ? (v / 10000).toFixed(2) : 0
    }
  },
  computed: {
    statistic() {
      return this.$store.state.bmap.topStat
    }
  }
}
</script>

<style lang="scss" scoped>
.map_stat_data {
  position: relative;
  height: 50px;
  margin-bottom: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.09);

  .stat_data_inner {
    position: absolute;
    width: 100%;
    height: 100px;
    top: -50px;
    left: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .stat_data_left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 100%;
    background: linear-gradient(315deg, rgba(250, 234, 97, 1) 0%, rgba(255, 184, 31, 1) 100%);
    border-radius: 10px 0 0 10px;

    .stat_title {
      width: 20px;
      font-size: 18px;
      font-weight: bold;
    }
  }

  .stat_data_right {
    display: flex;
    align-items: center;
    width: calc(100% - 40px);
    height: 100%;
    background: #fff;
    border-radius: 0 10px 10px 0;

    .stat_item {
      flex: 1 0 33.33%;

      &:not(:first-child) {
        box-shadow: -1px 0 0 0 #e9e9e9;
      }

      .item_label {
        color: #999;
        line-height: 20px;
      }

      .Akrobat-ExtraBold {
        font-size: 24px;
        font-weight: bold;
        line-height: 28px;

        .unit {
          font-size: 16px;
          font-weight: normal;
        }
      }
    }
  }
}
</style>
